import { TabLink } from "@/src/components/buttons/components/TabLink";
import { usePathname, useSearchParams } from "next/navigation";
import { TabContainer } from "nvs-design-system/dist/TabContainer";
import { PROFILE_TABS, renderTab } from "./renderTabs";
import { useGeoLoc } from "@/libs/geo/GeoLocProvider";

type ProfileTabsProps = {
  swooshHandle: string;
};

const ProfileTabs: React.FC<ProfileTabsProps> = ({ swooshHandle }) => {
  const tabs = [PROFILE_TABS.OWNED, PROFILE_TABS.FAVORITED];
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const tab = searchParams?.get("tab") ?? PROFILE_TABS.OWNED;
  const geo = useGeoLoc();

  return (
    <div>
      <TabContainer>
        {tabs.map((currTab) => (
          <TabLink
            key={currTab}
            href={{
              pathname,
              query: { tab: currTab },
            }}
            shallow // change the URL without running data fetching methods again
            scroll={false} // We need this so the page doesn't scroll to top on tab clicks
            isSelected={tab === currTab}
            size={"sm"}
            data-testid={currTab}
          >
            {currTab}
          </TabLink>
        ))}
      </TabContainer>

      <div className="pt-3 laptop:pt-6 pb-40">
        {tab && <>{renderTab(tab, swooshHandle)}</>}
      </div>
    </div>
  );
};

export default ProfileTabs;
